import { atom, RecoilState } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();
export const ConsolidationAtom: RecoilState<boolean> = atom<boolean>({
    key: 'ConsolidationAtom',
    default: false,
    effects_UNSTABLE : [persistAtom]
});
